import React, { Fragment, useEffect, useState } from 'react';
import AppCard from '@crema/core/AppCard';
import { Breadcrumbs, Stack, Typography } from '@mui/material';
import { SoalSection } from './SoalSection';
import { COLORS } from 'shared/constants/AppEnums';
import { ButtonContained, ButtonOutlined } from 'shared/components/Button';
import DialogKonfirmasi from 'shared/components/DialogKonfirmasi'
import { useDispatch } from 'react-redux';
import { onAddSurvey } from 'redux/actions';
import { useSelector } from 'react-redux';
import AppLoader from '@crema/core/AppLoader';
import AppInfoView from '@crema/core/AppInfoView';
import { FETCH_ERROR, FETCH_SUCCESS, SHOW_MESSAGE } from 'shared/constants/ActionTypes';
import HasilSurvey from './HasilSurvey';
import { useNavigate } from 'react-router-dom';
import { useAuthUser } from '@crema/utility/AuthHooks';

export const surveyAppConfig = [
    {
        path: '/survey',
        element: <SurveyApp />
    },
    {
        path: '/survey/hasil',
        element: <HasilSurvey />
    },
]

export default function SurveyApp() {
    const [dataPenggunaan, setDataPenggunaan] = useState({
        'Modul yang sudah digunakan': [],
        'Modul yang paling sering digunakan': [],
        'Modul yang paling disukai': []
    });
    const [penilaian, setPenilaian] = useState({
        'Portal Collaboration Office dapat diakses dengan baik pada penjelajah (browser) saya': [],
        'Akses login Portal Collaboration Office memiliki tingkat keamanan yang baik': [],
        'Portal Collaboration Office dapat diakses setiap hari': [],
        'Portal Collaboration Office mudah digunakan': [],
        'Informasi pada Portal Collabaration Office tersaji sesuai dengan kebutuhan': []
    });
    const [validation, setValidation] = useState([])

    const pilihanJawaban = [
        {
            value: 1,
            label: 'Sangat tidak setuju'
        },
        {
            value: 2,
            label: 'Tidak setuju'
        },
        {
            value: 3,
            label: 'Biasa saja/netral'
        },
        {
            value: 4,
            label: 'Setuju'
        },
        {
            value: 5,
            label: 'Sangat setuju'
        }
    ];

    const pilihanApps = [
        "Regulasi",
        "Korespondensi",
        "Portal Pegawai",
        "Email",
        "Digital Sign",
        "Cuti",
        "SPPD",
        "Agenda/Kalender",
        "Task Management",
        "Repositori",
        "Chat",
        "Video Conference",
        "Helpdesk",
        "Pengetahuan",
        "Aksi Perubahan",
        "Sertifikat",
        "E-Learning"
    ];

    const keysPenilaian = Object.keys(penilaian).map(item => item);
    const keysData = Object.keys(dataPenggunaan).map(item => item);
    const dispatch = useDispatch()
    const { loading } = useSelector(state => state.common)
    const navigation = useNavigate()
    const { user } = useAuthUser()

    const onChangeDataHandler = (key, value) => {
        const realKey = key.split('. ')[1].replace(':', '');
        const dataPrev = { ...dataPenggunaan };
        const arrayData = dataPrev[realKey];
        const index = arrayData.indexOf(value);

        if (index > -1) {
            arrayData.splice(index, 1)
        } else {
            arrayData.push(value);
        }

        setDataPenggunaan({
            ...dataPenggunaan,
            [realKey]: arrayData
        })

    }

    const onChangePenilaianHandler = (key, value) => {
        const realKey = key.split('. ')[1].replace(':', '');
        const actualValue = parseInt(value)
        setPenilaian({
            ...penilaian,
            [realKey]: [actualValue]
        })
    }

    const [menuKonfirmasi, setMenuKonfirmasi] = useState({
        toggle: false,
        id: ''
    })

    const handleCloseMenu = (status = 0) => {
        if (status === 1) {
            if (menuKonfirmasi.id === 'submit') {
                const { status, dataValidation } = handleValidation()
                if (status) {
                    setValidation(dataValidation)
                    dispatch({
                        type: FETCH_ERROR,
                        payload: 'Mohon masukan survei dengan benar'
                    })
                } else {
                    const payload = {
                        response: {
                            ...dataPenggunaan,
                            ...penilaian
                        }
                    }
                    dispatch(onAddSurvey(payload))
                    resetState()
                }
            } else {
                dispatch({
                    type: SHOW_MESSAGE,
                    payload: 'Data berhasil di reset'
                })
                resetState()
            }
        }
        setMenuKonfirmasi({
            toggle: false,
            id: ''
        })
    }

    const resetState = () => {
        setDataPenggunaan({
            'Modul yang sudah digunakan': [],
            'Modul yang paling sering digunakan': [],
            'Modul yang paling disukai': []
        });
        setPenilaian({
            'Portal Collaboration Office dapat diakses dengan baik pada penjelajah (browser) saya': [],
            'Akses login Portal Collaboration Office memiliki tingkat keamanan yang baik': [],
            'Portal Collaboration Office dapat diakses setiap hari': [],
            'Portal Collaboration Office mudah digunakan': [],
            'Informasi pada Portal Collabaration Office tersaji sesuai dengan kebutuhan': []
        })
        setValidation([])
    }

    useEffect(() => {
        return () => {
            resetState();
        }
    }, [])

    const handleValidation = () => {
        let validation = []
        Object.keys(dataPenggunaan).map((item, index) => {
            let value = Object.values(dataPenggunaan)[index]
            if (value.length === 0) {
                validation.push(item)
            }
        })
        Object.keys(penilaian).map((item, index) => {
            let value = Object.values(penilaian)[index]
            if (value.length === 0) {
                validation.push(item)
            }
        })
        return {
            status: validation.length === 0 ? false : true,
            dataValidation: validation
        }
    }

    return (
        <Stack
            gap={5}
            direction={'column'}
        >
            <Stack id='headerSurvey' sx={{ transition: '0.5s ease-in-out' }} direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                <Breadcrumbs aria-label='breadcrumb'>
                    <Typography
                        sx={{ cursor: 'pointer', fontWeight: 'bold' }} color={'primary.default'}
                        variant='h3'
                        onClick={() => {
                            navigation(`/survey`)
                        }}
                    >
                        Survey Layanan Aplikasi Sistem Informasi
                    </Typography>
                </Breadcrumbs>

                {
                    user?.roles_access.includes('USER_REPORT_SURVEY') ? (
                        <ButtonContained onClick={() => navigation('/survey/hasil')}>
                            Lihat Hasil Survey
                        </ButtonContained>
                    ) : null
                }
            </Stack>

            <AppCard>
                <Stack spacing={4}>
                    <Stack bgcolor={COLORS.primary} color={'white'} borderRadius={2}>
                        <Typography sx={{ m: 2, fontWeight: 'bold', fontSize: '16px' }}>Data Penggunaan</Typography>
                    </Stack>
                    <Stack
                        gap={3}
                        direction='column'
                        ml={'16px !important'}
                        sx={{
                            '& .MuiButtonBase-root.MuiRadio-root': {
                                display: 'block !important'
                            }
                        }}
                    >
                        {keysData && keysData.map((item, index) => (
                            <Fragment key={index + item}>
                                <SoalSection
                                    tipe='multi-choices'
                                    pilihan={pilihanApps}
                                    data={dataPenggunaan}
                                    pertanyaan={`${index + 1}. ${item}:`}
                                    onClick={(key, value) => onChangeDataHandler(key, value)}
                                    validation={validation}
                                />
                            </Fragment>
                        ))}
                    </Stack>
                </Stack>
            </AppCard>

            <AppCard>
                <Stack spacing={4}>
                    <Stack bgcolor={COLORS.primary} color={'white'} borderRadius={2}>
                        <Typography sx={{ m: 2, fontWeight: 'bold', fontSize: '16px' }}>Penilaian Kualitas dan Layanan</Typography>
                    </Stack>
                    <Stack
                        gap={3}
                        direction='column'
                        ml={'16px !important'}
                        sx={{
                            '& .MuiButtonBase-root.MuiRadio-root': {
                                display: 'block !important'
                            }
                        }}
                    >
                        {keysPenilaian && keysPenilaian.map((item, index) => (
                            <Fragment key={index + item}>
                                <SoalSection
                                    data={penilaian}
                                    tipe='one-choice'
                                    pilihan={pilihanJawaban}
                                    pertanyaan={`${index + 1}. ${item}`}
                                    onClick={(key, value) => onChangePenilaianHandler(key, value)}
                                    validation={validation}
                                />
                            </Fragment>
                        ))}
                    </Stack>
                </Stack>
            </AppCard>

            <Stack direction={'row'} justifyContent={'flex-end'} spacing={2}>
                <ButtonOutlined onClick={() => setMenuKonfirmasi({ toggle: true, id: 'reset' })} variant='outlined' disabled={false}>Reset</ButtonOutlined>
                <ButtonContained onClick={() => setMenuKonfirmasi({ toggle: true, id: 'submit' })} disabled={false}>Submit</ButtonContained>
            </Stack>

            <DialogKonfirmasi
                open={menuKonfirmasi.toggle}
                handleClose={handleCloseMenu}
                labelPesan={menuKonfirmasi.id === 'submit' ? 'Submit Survey' : 'Reset Survey'}
                isiPesan={`Apakah anda yakin akan ${menuKonfirmasi.id === 'submit' ? 'mengirim' : 'mereset'} survei?`}
                labelTombol='Ya'
            />

            {loading && <AppLoader />}
            <AppInfoView />
        </Stack >
    )
}